import React from 'react';
import { getFormatNumberWithCommas } from '../../modules/timeline/components/EnterButton/utils';
import { AppContext } from '../../apollo/wrap-root-element';
import { navigate } from 'gatsby';
import CurrencySwitcher from '../Header/currencyswitcher/CurrencySwitcher';

const DonationProjectCard = ({
  shortDescriptions,
  raisedMoney,
  raisedPercentage,
  goal,
  title,
  projectId,
  image,
  uid,
  isLanguageProject,
}) => {
  const { donatingProjectId, setDonatingProjectId } = React.useContext(AppContext);

  return (
    <div
      className="cols"
      onClick={() => {
        if (projectId === 'Religious Liberty Series') {
          navigate(`/religious-liberty-series`);
        } else if (isLanguageProject) {
          navigate(`/language-donations-page`);
        } else {
          setDonatingProjectId(projectId);
          navigate(`/donate/${uid}`);
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      <div className="project-donation-card-item bg-white" style={{ height: '100%' }}>
        <div>
          <div className="scale-on-hover">
            <img width={'100%'} height={'100%'} src={image} alt={title} />
          </div>
          <div className="project-donation-card-item-body">
            <div className="project-donation-card-content">
              <p className="title">{title}</p>
              <div className="progress-track">
                <div className="progress-thumb" style={{ width: raisedPercentage }}></div>
              </div>
              <div className="goal-container">
                <p>
                  <b>
                    <CurrencySwitcher price={+raisedMoney} isCommaSeparated={true} caller="donation p c" />
                  </b>
                  <span className="goals-raised-text">Raised</span>
                </p>
                <p>
                  <b>
                    <CurrencySwitcher price={+goal} isCommaSeparated={true} caller="donation p c2" />
                  </b>
                  <span className="goals-raised-text">Goal</span>
                </p>
              </div>
              <p className="descriptions">{shortDescriptions}</p>
            </div>

            <div className="btn-group-donate">
              {projectId === 'Religious Liberty Series' ? (
                <button
                  onClick={() => {
                    if (projectId === 'Religious Liberty Series') {
                      navigate(`/religious-liberty-series`);
                    } else if (isLanguageProject) {
                      navigate(`/language-donations-page`);
                    } else {
                      setDonatingProjectId(projectId);
                      navigate(`/donate/${uid}`);
                    }
                  }}
                  className="btn btn-md btn-primary-ii  give-button"
                >
                  Give
                </button>
              ) : (
                <button
                  onClick={() => {
                    if (projectId === 'Religious Liberty Series') {
                      navigate(`/religious-liberty-series`);
                    } else if (isLanguageProject) {
                      navigate(`/language-donations-page`);
                    } else {
                      setDonatingProjectId(projectId);
                      navigate(`/donate/${uid}`);
                    }
                  }}
                  className="btn btn-md btn-primary-ii  give-button"
                >
                  Give
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationProjectCard;
